
import React from 'react'
import Alert from 'ui/Alert'
import Link from 'ui/Link'

const MissingTokenAlert = () => (
  <Alert type='danger'>
    No token found, please only visit this page using a link from an email
    sent by the <Link href='/forgot' rel='external'>forgot your password form</Link>.
  </Alert>
)

const InvalidTokenAlert = () => (
  <Alert type='danger'>
    That token appears to be expired, if you still need to reset your password,
    try submitting the <Link href='/forgot' rel='external'>forgot your password form</Link> again.
  </Alert>
)

const GenericAlert = () => (
  <Alert type='danger'>
    An unexpected error has occurred. Email us at <Link href='mailto:friends@segment.com' target='_blank'>friends@segment.com</Link> so we can help you resolve this right away!
  </Alert>
)

const ResetError = props => {
  let alert = <GenericAlert />
  if (props.missing) {
    alert = <MissingTokenAlert />
  } else if (props.invalid) {
    alert = <InvalidTokenAlert />
  }
  return <div>{alert}</div>
}

export default ResetError



// WEBPACK FOOTER //
// ./components/ResetError.js